import React, { useState, useEffect } from 'react';
import { FaSearch, FaSlidersH, FaPaperclip } from 'react-icons/fa';
import SearchSettings from '../SearchSettings/SearchSettings';
import './SearchBar.css';
import FileUpload from '../FileUpload/FileUpload';
import { useTranslation } from 'react-i18next';
import { fileToBase64 } from '../../utils/fileToBase64';
import { useAppContext } from '../../context/AppContext';

const SearchBar = ({
    onSearch,
    placeholder,
    value,
    onChange,
    searchSettings,
    onSettingsApply,
    isMainPage = false,
    files,            
    setFiles,         
    isSending,        
    errorMessage  ,    
    fileProcessType,
    setFileProcessType 

}) => {
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [localValue, setLocalValue] = useState('');
    const [isUploadOpen, setIsUploadOpen] = useState(false);
    const { t } = useTranslation();
    const { userId, token } = useAppContext();

    useEffect(() => {
        setLocalValue(value || '');
    }, [value]);

    const toggleSettings = () => {
        setIsSettingsOpen(!isSettingsOpen);
        if (!isSettingsOpen) setIsUploadOpen(false);   // ← Ayarlar açılırken, upload paneli varsa kapansın

    };

    // Bu satırları, handleSettingsApply tanımından hemen sonra ekleyin:
    const toggleUpload = () => {
        setIsUploadOpen(!isUploadOpen);
        if (!isUploadOpen) setIsSettingsOpen(false);  // Upload açılırken, ayarlar panelini kapat
    };
    const closeUpload = () => setIsUploadOpen(false);

    // İsterseniz, seçilen dosyayı parent’a iletebilmek için basit bir callback:
    const handleFileSelect = (file) => {
        console.log('Seçilen dosya:', file);
        closeUpload();
    };


    const closeSettings = () => {
        setIsSettingsOpen(false);
    };

    const handleSearch = async () => {
        if (localValue?.trim()) {
            onSearch(localValue);
        }
    };


    const handleInputChange = (e) => {
        const newValue = e.target.value;
        setLocalValue(newValue);
        onChange?.(newValue);
    };

    const handleSettingsApply = (settings) => {
        onSettingsApply?.(settings);
        setIsSettingsOpen(false);
    };

    useEffect(() => {
    }, [])

    return (
        <div className={`searchbar-container ${isSettingsOpen || isUploadOpen ? 'focused' : ''}`}>
            <input
                type="text"
                value={localValue}
                onChange={handleInputChange}
                placeholder={t(placeholder || 'Bir soru sorun veya araştırma konusu yazın...')}
                className="search-input"
                onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
            />


            <div className="search-icons">

                    <FaPaperclip
                        className={`upload-icon ${isUploadOpen ? "active" : ""}`}
                        title="Kendi dosyalarınızı yükleyerek Piri AI'de bu dosyalardan yararlanmasını sağlayabilirsiniz."
                        onClick={toggleUpload}
                    />

                <FaSlidersH
                    className="slider-icon"
                    onClick={toggleSettings}
                />
                <FaSearch
                    className="search-icon"
                    onClick={handleSearch}
                />
            </div>

            <SearchSettings
                isOpen={isSettingsOpen}
                closeSettings={closeSettings}
                onApply={handleSettingsApply}
                defaultSettings={searchSettings}
            />

            <FileUpload
                isOpen={isUploadOpen}
                closeUpload={closeUpload}
                files={files}
                setFiles={setFiles}
                fileProcessType={fileProcessType}
                setFileProcessType={setFileProcessType}
            />



        </div>
    );
};

export default SearchBar;